import { call, put, select } from 'redux-saga/effects';
import { fetchEtimClassFilter } from '../api';
import { setProductClassOptions } from '../actions/productClassesActions';
import { selectors as userSelectors } from '../reducers/userReducer';
import { buildApiLocales } from '../intl-helpers';

/**
 * Carica le classi ETIM e le mette nello state.
 * Usa un payload pulito, senza filtri, in modo da avere tutte le classi
 * ETIM disponibili nelle options.
 *
 * NON sovrascrive il bootstrappedAppState: quello deve rimanere sempre
 * lo snapshot iniziale dell'applicativo creato da initializeBootstrappedState.
 * Le classi ETIM vengono ri-fetchate quando necessario da refreshFiltersValues.
 */
export function* loadEtimClasses() {
    const user = yield select(userSelectors.getUser)
    const userLocale = user?.locale || 'it_IT'

    const payload = {
        "per_page": 40,
        "page": 1,
        "include_accessori": true,
        "include_ricambi": true,
        "locales": buildApiLocales(userLocale),
        "product_tree": "etim"
    }

    const etimClassRes = yield call(fetchEtimClassFilter, payload)
    yield put(setProductClassOptions(etimClassRes.data))
}